import { ApiTransaction } from '@vend/types'
import { Omit } from '@stripe/stripe-js/types/utils'
import { withRetry } from '../../helpers/withRetry'
import { refund } from '../../helpers/refund'
import { LSPAYRefundOptions } from '../../helpers/lspay.types'

/**
 * Try to save a refund in swiper.
 * Has a built in retry mechanism.
 * Retry 3 times, with a wait in between each retry.
 * If it fails after 3 trys throw an error
 *
 * @returns The completed refund transaction
 */
export const persistRefund = async (
  lspayRefundOptions: Omit<LSPAYRefundOptions, 'unreferencedPaymentMethodID'>
) => await withRetry<ApiTransaction>(() => refund(lspayRefundOptions), 'refund')
